import React from "react";
import { ChevronDown, History, Plus, Settings2, Upload } from "lucide-react";
import { SidebarAside } from "modules/common/components/SidebarPageLayout";
import { CollectionAppraisalSkeleton } from "./CollectionAppraisalSkeleton";

const COLLAPSED_GROUPS = ["Types", "Condition", "Rarity", "Price"] as const;

/** Standalone loading skeleton matching FacetSidebar's initial state */
export function FacetSidebarSkeleton() {
  return (
    <div className="flex flex-col">
      {/* Header: "Filters" + settings gear */}
      <div className="flex items-center justify-between px-2 py-1">
        <h3 className="text-base-content text-base font-semibold">Filters</h3>
        <span className="btn btn-ghost btn-xs btn-square pointer-events-none">
          <Settings2 size={14} />
        </span>
      </div>

      {/* Expanded group: "Sets" */}
      <div className="border-base-content/10 border-b">
        <div className="flex flex-1 items-center gap-2 px-2 py-1.5 text-sm font-medium">
          <ChevronDown size={14} className="shrink-0" />
          <span className="flex-1 text-left">Sets</span>
        </div>
        <div className="flex flex-col gap-0.5 px-1 pb-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="flex items-center gap-2 rounded px-1 py-0.5 text-sm"
            >
              <input
                type="checkbox"
                className="checkbox checkbox-xs checkbox-primary"
                disabled
                tabIndex={-1}
              />
              <div
                className="skeleton h-3.5 flex-1 rounded"
                style={{ width: `${55 + ((i * 17) % 35)}%` }}
              />
              <div className="skeleton h-3 w-6 rounded" />
            </div>
          ))}
        </div>
      </div>

      {/* Collapsed groups */}
      {COLLAPSED_GROUPS.map((title) => (
        <div
          key={title}
          className="border-base-content/10 border-b last:border-b-0"
        >
          <div className="flex flex-1 items-center gap-2 px-2 py-1.5 text-sm font-medium">
            <ChevronDown size={14} className="shrink-0 -rotate-90" />
            <span className="flex-1 text-left">{title}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

/** Full sidebar skeleton: appraisal + action buttons + facet filters */
export function SidebarSkeleton() {
  return (
    <SidebarAside
      sidebarHeader={
        <>
          <CollectionAppraisalSkeleton />

          <div className="pointer-events-none flex gap-2">
            <span className="btn btn-primary btn-sm flex-1 gap-1">
              <Plus size={18} />
              Add Card
            </span>
            <span className="btn btn-ghost btn-sm gap-1">
              <Upload size={14} />
            </span>
            <span className="btn btn-ghost btn-sm gap-1">
              <History size={14} />
            </span>
          </div>
        </>
      }
    >
      <FacetSidebarSkeleton />
    </SidebarAside>
  );
}
